import React, { useState } from "react";
import useUserStore from "../store/useUserStore";

import Button from "../utils/Button";
import InputText from "../utils/InputText";
import classes from "./SignupForm.module.css";

import { useNavigate } from "react-router";
import useAppStore from "../store/useAppStore";

import showPass from "../assests/images/show.png";
import hidePass from "../assests/images/hide.png";

export default function SignupForm() {
  const [show, setShow] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",

    age: "",
    name: "",
    lastName: "",
  });

  const [passwordCheck, setPasswordCheck] = useState("no value");
  const { createUser } = useUserStore((state) => state);
  const navigate = useNavigate();
  const handleChange = (event) => {
    const { name, value } = event.target;
    const newFormData = { ...formData };
    newFormData[name] = value;
    setFormData(newFormData);
  };

  const submitHandler = (event) => {
    // Standardverhalten abbrechen
    event.preventDefault();
    if (!passwordCheck) return;
    // Daten als Formular aufbereiten
    const submitForm = new FormData();
    submitForm.append("name", formData.name);
    submitForm.append("lastName", formData.lastName);
    submitForm.append("email", formData.email);
    submitForm.append("age", formData.age);
    submitForm.append("password", formData.password);

    // an Zustand Methode senden

    createUser(submitForm);

    useAppStore.getState().userCreated &&
      setFormData({
        email: "",
        password: "",
        age: "",
        name: "",
        lastName: "",
      });

    if (useAppStore.getState().success) return;

    setTimeout(() => {
      navigate("/login");
      useAppStore.setState({ success: false });
    }, 5000);
  };

  const handleCheck = (e) => {
    e.target.value === formData.password
      ? setPasswordCheck(true)
      : setPasswordCheck(false);
  };
  const handleChangeShowHidePass = (event) => {
    setShow((state) => !state);
  };
  const handleChangeCheckPassShow = (event) => {
    setShowCheck((state) => !state);
  };

  const value = () => {
    if (passwordCheck === "no value") {
      return "";
    } else if (passwordCheck === false) {
      return "red";
    } else {
      return "green";
    }
  };

  return (
    <form onSubmit={submitHandler} className={classes.signupForm}>
      <InputText
        onChange={handleChange}
        name="name"
        value={formData.name}
        type="text"
        placeholder="Name"
        required="required"
      />
      <InputText
        onChange={handleChange}
        name="lastName"
        value={formData.lastName}
        type="text"
        placeholder="Last Name"
        required="required"
      />
      <InputText
        onChange={handleChange}
        name="age"
        value={formData.age}
        type="text"
        placeholder="age"
        required="required"
      />
      <InputText
        onChange={handleChange}
        name="email"
        value={formData.email}
        type="text"
        placeholder="E-mail"
        required="required"
      />
      <div className={classes.inputPass}>
        <InputText
          style={{ width: "100%" }}
          type={show ? "text" : "password"}
          placeholder="Password"
          onChange={handleChange}
          name="password"
          required="required"
        />
        <div className={classes.showHidePass}>
          <img
            onClick={handleChangeShowHidePass}
            width="100%"
            alt="show"
            src={show ? hidePass : showPass}
          />
        </div>
      </div>

      <div className={classes.inputPass}>
        <InputText
          type={showCheck ? "text" : "password"}
          placeholder="Password"
          onChange={handleCheck}
          name="password"
          // eslint-disable-next-line react/jsx-no-duplicate-props
          style={{ width: "100%", border: `3px solid ${value()}` }}
          required="required"
        />
        <div className={classes.showHidePass}>
          <img
            onClick={handleChangeCheckPassShow}
            width="100%"
            alt="show"
            src={showCheck ? hidePass : showPass}
          />
        </div>
      </div>

      <Button style={{ width: "100%", gridColumn: "1 / 3" }}>Sign up</Button>
    </form>
  );
}
